module.exports = __webpack_public_path__ + "static/media/README.70a27ec9.md";